import Styles from './Hints.module.scss';
import { useState } from 'react';
// Components imports.
import { useTranslation } from 'components/lib';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
// Material imports.
import {
    Fab, Paper, Slide, Collapse, ToggleButton,
    Typography, Fade, Tooltip, Avatar
} from '@mui/material';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
// material Icons imports
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';


export function Hints(props) {

    const { t } = useTranslation();

    const [showHintsDialogue, setShowHintsDialogue] = useState(false);
    const [showHint1, setShowHint1] = useState(false);
    const [showHint2, setShowHint2] = useState(false);
    const [hintsUsed, setHintsUsed] = useState(0);

    const [showHintConfirmation, setShowHintConfirmation] = useState(false);
    const [clickedHintButton, setClickedHintButton] = useState('');

    const handleHints = () => {
        setShowHintsDialogue((prev) => !prev)
    };

    const handleHintsOnClickAway = () => {
        if (showHintsDialogue) {
            setShowHintsDialogue(false);
        }
    };

    const handleHintConfirmCard = () => {
        setShowHintConfirmation(true);
    };

    const handleHintClick = () => {
        const hint_display_id = clickedHintButton === 'hint-1-button' ? 1 : 2;
        props.handleHintClick(hint_display_id, hintsUsed + 1);
        if (hint_display_id === 1) {
            setShowHint1(true);
        } else if (hint_display_id === 2) {
            setShowHint2(true);
        }
        setHintsUsed(hintsUsed + 1);

    };

    return (
        <>
            <ClickAwayListener onClickAway={handleHintsOnClickAway}>
                <div>
                    {showHintConfirmation && (
                        <ConfirmationCard
                            title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.confirmCard.title')}
                            body={t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.confirmCard.message')}
                            showCard={showHintConfirmation}
                            setShowCard={setShowHintConfirmation}
                            handleConfirm={handleHintClick}
                        />
                    )}
                    <div id="parentContainer"
                        className={Styles.parentContainer}
                    >
                        <Slide
                            direction="up"
                            in={showHintsDialogue}
                            mountOnEnter
                            unmountOnExit
                        >
                            <div
                                id='hintInteractHolder'
                                width='100%'
                                // elevation={24}
                                style={{
                                    height: 250,
                                    backgroundColor: "transparent",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    marginBottom: '55px',
                                    marginRight: '-12px',
                                }}
                            >
                                <Paper
                                    id='hint-1-container'
                                    width='95%'
                                    elevation={8}
                                    sx={{
                                        height: '43%',
                                        // backgroundColor: teal[100],
                                        backgroundColor: "#90caf9",
                                        display: 'flex',
                                        flexDirection: 'column',
                                        margin: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: "200px",
                                        borderBottomLeftRadius: "0px",
                                    }}
                                >
                                    {showHint1 ? (
                                        <Fade
                                            in={showHint1}
                                            style={{ transformOrigin: '0 0 0' }}
                                            timeout={1000}
                                            sx={{ width: '100%', height: '100%' }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between', // Aligns the elements to the start and end of the container
                                                alignItems: 'center', // Vertically center the elements
                                                padding: '2px',
                                                borderRadius: "200px",
                                                width: "289px",
                                                height: "100px"
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%'
                                                }}>
                                                    <Typography
                                                        align='center'
                                                        sx={{
                                                            fontWeight: 700,
                                                            flex: 1,
                                                            ml: '1px',
                                                            textAlign: 'center',
                                                            color: "rgba(0, 0, 0, 0.54)"
                                                        }}
                                                    >
                                                        {props.hint1Text}
                                                    </Typography>
                                                </div>
                                                <Avatar sx={{
                                                    bgcolor: showHint1 ? "#4caf50" : "#393E46",
                                                    width: 96,
                                                    height: 96,
                                                    display: "flex",
                                                    alignSelf: "auto",
                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.25)",
                                                    margin: "1px"
                                                }}>1</Avatar>
                                            </div>
                                        </Fade>
                                    ) : (
                                        <Collapse
                                            orientation="horizontal"
                                            in={!showHint1}
                                            sx={{ width: '100%', height: '100%' }}
                                        >
                                            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.hint.tooltip')}>
                                                <ToggleButton
                                                    id='hint-1-button'
                                                    value="check"
                                                    size="large"
                                                    sx={{
                                                        height: '100px',
                                                        width: '289px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'space-between', // Aligns the elements to the start and end of the container
                                                        alignItems: 'center', // Vertically center the elements
                                                        padding: '2px',
                                                        borderRadius: "200px",
                                                        border: "none",
                                                        fontWeight: 700,
                                                        borderBottomLeftRadius: "0px"
                                                    }}
                                                    onClick={() => {
                                                        setClickedHintButton('hint-1-button');
                                                        handleHintConfirmCard();
                                                    }}
                                                >
                                                    <Typography
                                                        align='center'
                                                        sx={{ fontWeight: 800, flex: 1, ml: '1px' }}
                                                    >
                                                        {t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.hint.text')} </Typography>
                                                    <Avatar sx={{
                                                        bgcolor: "#393E46",
                                                        width: 96,
                                                        height: 96,
                                                        display: "flex",
                                                        alignSelf: "auto",
                                                        margin: "1px"
                                                    }}>1</Avatar>
                                                </ToggleButton>
                                            </Tooltip>
                                        </Collapse>
                                    )}
                                </Paper>
                                <Paper
                                    id='hint-2-container'
                                    width='95%'
                                    elevation={8}
                                    sx={{
                                        height: '43%',
                                        // backgroundColor: teal[100],
                                        backgroundColor: "#90caf9",
                                        display: 'flex',
                                        flexDirection: 'column',
                                        margin: '12px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: "200px",
                                        // borderTopRightRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                    }}
                                >
                                    {showHint2 ? (
                                        <Fade
                                            in={showHint2}
                                            style={{ transformOrigin: '0 0 0' }}
                                            timeout={1000}
                                            sx={{ width: '100%', height: '100%' }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between', // Aligns the elements to the start and end of the container
                                                alignItems: 'center', // Vertically center the elements
                                                padding: '2px',
                                                borderRadius: "200px",
                                                width: "289px",
                                                height: "100px"

                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%'
                                                }}>
                                                    <Typography
                                                        align='center'
                                                        sx={{
                                                            fontWeight: 700,
                                                            flex: 1,
                                                            ml: '1px',
                                                            textAlign: 'center',
                                                            color: "rgba(0, 0, 0, 0.54)"
                                                        }}
                                                    >
                                                        {props.hint2Text}
                                                    </Typography>
                                                </div>
                                                <Avatar sx={{
                                                    bgcolor: showHint2 ? "#4caf50" : "#393E46",
                                                    width: 96,
                                                    height: 96,
                                                    display: "flex",
                                                    alignSelf: "auto",
                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.25)",
                                                    margin: "1px"
                                                }}>2</Avatar>
                                            </div>
                                        </Fade>
                                    ) : (
                                        <Collapse
                                            orientation="horizontal"
                                            in={!showHint2}
                                            style={{ transformOrigin: '0 0 0' }}
                                            {...(!showHint2 ? { timeout: 1000 } : {})}
                                            sx={{ width: '100%', height: '100%' }}
                                        >
                                            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.hint.tooltip')}>
                                                <ToggleButton
                                                    id='hint-2-button'
                                                    value="check"
                                                    size="large"
                                                    sx={{
                                                        height: '100px',
                                                        width: '289px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent: 'space-between', // Aligns the elements to the start and end of the container
                                                        alignItems: 'center', // Vertically center the elements
                                                        padding: '2px',
                                                        borderRadius: "200px",
                                                        border: "none",
                                                        fontWeight: 700,
                                                        borderBottomLeftRadius: "0px"
                                                    }}
                                                    onClick={() => {
                                                        setClickedHintButton('hint-2-button');
                                                        handleHintConfirmCard();
                                                    }}
                                                >
                                                    <Typography
                                                        align='center'
                                                        sx={{ fontWeight: 800, flex: 1, ml: '1px' }}
                                                    >
                                                         {t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.hint.text')}
                                                    </Typography>
                                                    <Avatar sx={{
                                                        bgcolor: "#393E46",
                                                        width: 96,
                                                        height: 96,
                                                        display: "flex",
                                                        alignSelf: "auto",
                                                        margin: "1px"
                                                    }}>2</Avatar>
                                                </ToggleButton>
                                            </Tooltip>
                                        </Collapse>
                                    )}
                                </Paper>
                            </div>
                        </Slide>
                        <Fab
                            variant="extended"
                            sx={{
                                bgcolor: showHintsDialogue ? "#bddef8" : "#90caf9",
                                '&:hover': {
                                    bgcolor: "#bddef8",
                                },
                                display: 'flex',
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                width: "fit-content"
                            }}
                            onClick={() => {
                                handleHints();
                            }}
                        >
                            <TipsAndUpdatesTwoToneIcon sx={{ mr: 1 }} />
                            {t('Streams.ChallengeLevelOne.ChallengeLevelOne.hints.button')} </Fab>
                    </div >
                </div>
            </ClickAwayListener >
        </>
    );
}